import { render, staticRenderFns } from "./AutomacaoProcessosBC.vue?vue&type=template&id=7d35d401&scoped=true"
import script from "./AutomacaoProcessosBC.vue?vue&type=script&lang=js"
export * from "./AutomacaoProcessosBC.vue?vue&type=script&lang=js"
import style0 from "./AutomacaoProcessosBC.vue?vue&type=style&index=0&id=7d35d401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d35d401",
  null
  
)

export default component.exports